import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * 좌측 NavBar 접기/펼치기 상태 — themeStore 동형(zustand + persist).
 *
 *   - collapsed=false : expanded (아이콘 + 텍스트, --layout-navbar-w)
 *   - collapsed=true  : collapsed (아이콘만, --layout-navbar-w-collapsed)
 *
 * 적용 경로는 store → NavBar 가 `data-collapsed` 속성 출력 → CSS width/opacity transition
 * 으로 단방향(JS 애니메이션 없음). prefers-reduced-motion 사용자는 tokens.css 전역 게이트가
 * duration 을 0ms 로 강제하므로 본 store 는 모션을 신경 쓰지 않는다.
 *
 * persist 키 `workchat:sidebar` — 새로고침·재방문 시 선호 유지 (themeStore 의 workchat:theme 와 동일 정책).
 *
 * ★ 2026-09-07 — **초기값을 접힘으로 뒤집었다**(정본 F16 「접힘이 기본이다」).
 *   레일이 아이콘 전용 56px 이 되면서 접힘이 평상 모습이고, 머리의 버튼(H1-4)이나
 *   `Ctrl/Cmd+B` 로 편다.
 *   ⚠ **이미 저장해 둔 사람은 영향이 없다** — persist 가 초기값을 이긴다. 그게 맞다:
 *     사용자가 한 번 정한 것을 판올림이 되돌리면 안 된다. 옛 사용자까지 옮기려면
 *     persist 키를 갈아야 하는데, 그건 「내가 정한 걸 되돌렸다」가 되므로 하지 않는다.
 */
interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: true,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    { name: 'workchat:sidebar' },
  ),
);
